import BreadcrumbLink from "../common/breadcrumb";
import { useSelector } from "react-redux";

const TopSection = (props) => {
    const cardTitle = useSelector((state) => state?.userCardType.cardTitle);

    return (
        <div>
            <div
                style={ {
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 13,
                    padding: '10px 0px 10px 0px',
                } }
            >
                <div>
                    <BreadcrumbLink breadcrumbArray={ props?.breadcrumbArray } count={props.count} />
                </div>

            </div>
            { !props.hideTitle && <div
                style={ {
                    display: "flex",
                    flexDirection: "row",
                    fontSize: 13,
                    fontWeight: "bold",
                    padding: '0px 0px 20px 0px',
                } }
            >
                { props.hideHeader ? <div>{ props.headerName }</div> : <div>{ cardTitle } - { props?.tabTitle }</div> }
            </div> }

        </div>
    )
}

export default TopSection;